// ** Theme Type Import
import { Theme } from "@mui/material/styles";

const Typography = (theme: Theme) => {
  return {
    fontSize: 14,
    fontWeightLight: 400,
    fontWeightRegular: 400,
    fontWeightBold: 500,
    h1: {
      fontWeight: 500,
      fontSize: 24,
    },
    h2: {
      fontWeight: 500,
      fontSize: 20,
    },
    h3: {
      fontWeight: 500,
      fontSize: 18,
    },
    h4: {
      fontWeight: 500,
      fontSize: 14,
    },
    h5: {
      fontWeight: 400,
      fontSize: 14,
    },
    // default
    body1: {
      fontWeight: 400,
      fontSize: 14,
    },
    body2: {
      fontWeight: 400,
      fontSize: 12,
    },
    ...["h6", "subtitle1", "subtitle2", "default", "button", "overline"].reduce((prev, next) => {
      prev[next] = { fontWeight: 400, fontSize: 12 };
      return prev;
    }, {} as any),
  };
};

export default Typography;
